import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseReleaseCreateRequestDTO, PurchaseReleaseDeleteRequestDTO, PurchaseReleaseDTO, PurchaseReleaseList, PurchaseReleaseReadByTenantIdRequestDTO, PurchaseReleaseReadByIdRequestDTO, PurchaseReleaseSearchByReleaseNoRequestDTO, PurchaseReleaseUpdateRequestDTO } from './purchase-release.interface';
import { PurchaseRelease_Create, PurchaseRelease_Delete, PurchaseRelease_ReadAll, PurchaseRelease_ReadByTenantId, PurchaseRelease_ReadbyId, PurchaseRelease_SearchByReleaseNo, PurchaseRelease_Update } from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class PurchaseReleaseService {

  constructor(private http: HttpClient) { }

  PurchaseRelease_Create(data: PurchaseReleaseCreateRequestDTO): Observable<PurchaseReleaseDTO> {
    return this.http.post<PurchaseReleaseDTO>(PurchaseRelease_Create, data);
  }

  PurchaseRelease_Update(data: PurchaseReleaseUpdateRequestDTO): Observable<PurchaseReleaseDTO> {
    return this.http.post<PurchaseReleaseDTO>(PurchaseRelease_Update, data);
  }

  PurchaseRelease_Delete(data: PurchaseReleaseDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseRelease_Delete, data);
  }
  PurchaseRelease_ReadById(data: PurchaseReleaseReadByIdRequestDTO): Observable<PurchaseReleaseDTO> {
    return this.http.post<PurchaseReleaseDTO>(PurchaseRelease_ReadbyId, data);
  }
  PurchaseRelease_ReadAll(): Observable<PurchaseReleaseList> {
    return this.http.get<PurchaseReleaseList>(PurchaseRelease_ReadAll);
  }
  PurchaseRelease_ReadByTenantId(data:PurchaseReleaseReadByTenantIdRequestDTO): Observable<PurchaseReleaseList> {
    return this.http.post<PurchaseReleaseList>(PurchaseRelease_ReadByTenantId,data);
  }

  PurchaseRelease_SearchByReleaseNo(data:PurchaseReleaseSearchByReleaseNoRequestDTO): Observable<PurchaseReleaseList> {
    return this.http.post<PurchaseReleaseList>(PurchaseRelease_SearchByReleaseNo,data);
  }
}
